import { render, staticRenderFns } from "./HelpActions.vue?vue&type=template&id=515d0cf6&scoped=true"
import script from "./HelpActions.vue?vue&type=script&lang=js"
export * from "./HelpActions.vue?vue&type=script&lang=js"
import style0 from "./HelpActions.vue?vue&type=style&index=0&id=515d0cf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515d0cf6",
  null
  
)

export default component.exports